import emrService from '@/apis/emr/service';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import RenderLines from '@/screens/BodyScreen/components/RenderLines';
import useBodyScreenStore from '@/screens/BodyScreen/store';
import useGlobalConfigs from '@/stores/globalConfigs';
import { usePhrStoreInContext } from '@/stores/phr';
import { Badge, Flex } from 'antd';
import * as React from 'react';

export interface IDrawBodyProps {}

const SectionBody: React.FC<IDrawBodyProps> = ({ ...props }) => {
  const config = useGlobalConfigs((s) => s.phrConfigs?.body || s.phrConfigs?.bodySystem);
  const setKeyBody = useBodyScreenStore((s) => s.setKeyBody);
  const resetBodyScreenStore = useBodyScreenStore((s) => s.resetBodyScreenStore);
  const setRefetchCountBody = useGlobalConfigs((s) => s.setRefetchCountBody);
  const uid = usePhrStoreInContext((s) => s.uid);
  const { data, refetch } = emrService.useCountHr(uid);
  const objCount = data?.data?.reduce((d: any, e: any) => {
    if (e._id) {
      d[e._id] = (d[e._id] || 0) + e.total;
    } else {
      d['other'] = (d['other'] || 0) + e.total;
    }
    return d;
  }, {});

  React.useEffect(() => {
    setRefetchCountBody(refetch);
  }, [refetch, setRefetchCountBody]);

  React.useEffect(() => {
    return () => resetBodyScreenStore();
  }, [resetBodyScreenStore]);

  const keyBody = useBodyScreenStore((s) => s.keyBody);

  /** Start line */
  const svgRef = React.useRef(null);

  return (
    <div
      className="w-full h-full flex justify-center items-center bg-center bg-no-repeat relative bg-contain"
      style={{ backgroundImage: 'url("/images/nguoi.svg")' }}
    >
      <BaseIconSvg
        className="wh-[70px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[250%] bg-white p-4 rounded-full logo-vclass"
        src="/icons/Line/logo.svg"
      />
      <div className="draws absolute w-full h-full z-[1] overflow-hidden">
        <svg className="w-full h-full" ref={svgRef}>
          <RenderLines svgRef={svgRef} />
        </svg>
      </div>
      <div className="flex flex-wrap relative z-[2]">
        {config?.map((c, i: number) => {
          const isEven = i % 2 === 0;
          const mid = Math.floor(config.length / 2);
          const h = mid - Math.abs(mid - (isEven ? i : i - 1));
          const l = (h + 2) * (window.innerWidth < 800 ? 10 : 20);
          const isActive = c.key === keyBody;
          return (
            <div key={i.toString()} className={`w-1/2 mb-8 xl:mb-14  p-2 flex ${isEven ? 'flex-row-reverse' : ''}`}>
              <div className="" style={{ width: `${l}px` }}></div>
              <span
                className="group"
                onClick={() => setKeyBody(keyBody && keyBody === c.key ? undefined : c.key)}
                onDoubleClick={() => {
                  console.log(c.key);
                }}
              >
                <Flex
                  gap={'5px'}
                  className={`cursor-pointer btn-he-co-quan flex items-center border w-40 border-white p-2 rounded-full bg-white bg-opacity-20 shadow ${
                    isEven ? 'flex-row-reverse' : ''
                  } group-hover:bg-yellow-1 group-hover:border-b-mint-10 ${isActive ? '!border-mint-10' : ''}`}
                >
                  <Badge count={objCount?.[c.key]}>
                    <BaseIconSvg
                      // src={c.icon}
                      src="/images/img-default.svg"
                      className={`${
                        isActive ? '!bg-mint-10 text-opacity-100' : ''
                      } bg-violet-14 bg-opacity-50 rounded-full p-2 wh-[34px] group-hover:bg-opacity-100 `}
                    />
                  </Badge>
                  <div
                    className={`${
                      isActive ? '!text-mint-14 text-opacity-100' : ''
                    } font-bold text-violet-14 text-opacity-50 group-hover:text-opacity-100 text-center w-full`}
                  >
                    {c.label}
                  </div>
                </Flex>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionBody;
